<!-- =========================================================================================
  File Name: team.vue
  Description: Report Team
========================================================================================== -->

<template>
  <div id="report-team">

    <vx-card title="团队报表">
      <div slot="actions" class="flex items-center">
        <div class="mr-8 flex items-center">
          <vs-checkbox v-model="showLottery">显示彩票</vs-checkbox>
          <vs-checkbox v-model="showGame">显示真人</vs-checkbox>
        </div>
        <vx-input-group>
          <template slot="prepend">
            <flat-pickr v-model="startTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          </template>
          <flat-pickr v-model="endTime" :config="flatPickrConfig" class="flatpickr-input w-32"></flat-pickr>
          <template slot="append">
            <vs-input class="w-32" v-model="uid" placeholder="UID / 用户名" />
          </template>
          <template slot="append">
            <vs-select class="w-32" v-model="range">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in rangeList" />
            </vs-select>
          </template>
          <template slot="append">
            <vs-select class="w-32" v-model="typeIndex">
              <vs-select-item :key="index" :value="index" :text="item" v-for="(item, index) in typeList" />
            </vs-select>
          </template>
          <template slot="append">
            <div class="append-text bg-warning cursor-pointer" @click="search">
              <feather-icon icon="SearchIcon"></feather-icon>
            </div>
          </template>
        </vx-input-group>
      </div>

      <vx-card>
        <vs-table stripe :data="list" noDataText="暂无报表记录" class=" w-full">
          <template slot="thead">
            <vs-th width="120">日期</vs-th>
            <vs-th>存款</vs-th>
            <vs-th>提款</vs-th>
            <vs-th>转账</vs-th>
            <vs-th v-if="showLottery && showGame">总投注</vs-th>
            <vs-th v-if="showLottery && showGame">总返奖</vs-th>
            <vs-th v-if="showLottery && showGame">总提成</vs-th>
            <vs-th v-if="showLottery">彩票投注</vs-th>
			<vs-th v-if="showLottery">彩票返奖</vs-th>
            <vs-th v-if="showGame">真人投注</vs-th>
            <vs-th v-if="showGame">真人返奖</vs-th>
            <!-- <vs-th v-if="showLottery">彩票提成</vs-th> -->
            <!-- <vs-th v-if="showGame">真人提成</vs-th> -->
			<vs-th v-if="showGame">真人转出</vs-th>
			<vs-th v-if="showGame">真人转入</vs-th>
            <vs-th>活动奖励</vs-th>
            <vs-th>投注盈利</vs-th>
            <vs-th>净盈利</vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="index" v-for="(item, index) in dateList" v-if="list[item]">
              <vs-td>{{item}}</vs-td>
              <vs-td :class="{ 'font-bold': format(list[item]['充值']) != 0 }">{{format(list[item]['充值']).toFixed(3)}}</vs-td>
              <vs-td :class="{ 'font-bold': format(list[item]['提现']) != 0 }">{{format(list[item]['提现']).toFixed(3)}}</vs-td>
              <vs-td :class="{ 'font-bold': format(list[item]['转账']) != 0 }">{{format(list[item]['转账']).toFixed(3)}}</vs-td>
              <vs-td v-if="showLottery && showGame" :class="{ 'font-bold': calBet(list[item], ['彩票', '真人'], '投注') != 0 }">{{calBet(list[item], ['彩票', '真人'], '投注').toFixed(3)}}</vs-td>
              <vs-td v-if="showLottery && showGame" :class="{ 'font-bold': calBet(list[item], ['彩票', '真人'], '返奖') != 0 }">{{calBet(list[item], ['彩票', '真人'], '返奖').toFixed(3)}}</vs-td>
              <vs-td v-if="showLottery && showGame" :class="{ 'font-bold': calBet(list[item], ['彩票', '真人'], '提成') != 0 }">{{calBet(list[item], ['彩票', '真人'], '提成').toFixed(3)}}</vs-td>
              <vs-td v-if="showLottery" :class="{ 'font-bold': calBet(list[item], ['彩票'], '投注') != 0 }">{{calBet(list[item], ['彩票'], '投注').toFixed(3)}}</vs-td>
			  <vs-td v-if="showLottery" :class="{ 'font-bold': calBet(list[item], ['彩票'], '返奖') != 0 }">{{calBet(list[item], ['彩票'], '返奖').toFixed(3)}}</vs-td>
              <vs-td v-if="showGame" :class="{ 'font-bold': calBet(list[item], ['真人'], '投注') != 0 }">{{calBet(list[item], ['真人'], '投注').toFixed(3)}}</vs-td>
              <vs-td v-if="showGame" :class="{ 'font-bold': calBet(list[item], ['真人'], '返奖') != 0 }">{{calBet(list[item], ['真人'], '返奖').toFixed(3)}}</vs-td>
              <!-- <vs-td v-if="showLottery" :class="{ 'font-bold': calBet(list[item], ['彩票'], '提成') != 0 }">{{calBet(list[item], ['彩票'], '提成').toFixed(3)}}</vs-td>
              <vs-td v-if="showGame" :class="{ 'font-bold': calBet(list[item], ['真人'], '提成') != 0 }">{{calBet(list[item], ['真人'], '提成').toFixed(3)}}</vs-td> -->
			  <vs-td v-if="showGame" :class="{ 'font-bold': calBet(list[item], ['真人'], '转出') != 0 }">{{calBet(list[item], ['真人'], '转出').toFixed(3)}}</vs-td>
			  <vs-td v-if="showGame" :class="{ 'font-bold': calBet(list[item], ['真人'], '转入') != 0 }">{{calBet(list[item], ['真人'], '转入').toFixed(3)}}</vs-td>
							
							
              <vs-td :class="{ 'font-bold': calBet(list[item], [showLottery ? '彩票' : null, showGame ? '真人' : null], '活动') != 0 }">{{calBet(list[item], [showLottery ? '彩票' : null, showGame ? '真人' : null], '活动').toFixed(3)}}</vs-td>
              <vs-td :class="{ 'font-bold': calSumJing(list[item]) }">{{calSumJing(list[item]).toFixed(3)}}</vs-td>
							<vs-td :class="{ 'font-bold': calSum(list[item]) }">{{calSum(list[item]).toFixed(3)}}</vs-td>
            </vs-tr>
            <vs-tr>
              <vs-td class="font-bold">合计</vs-td>
              <vs-td :class="{ 'font-bold': format(sum['充值']) != 0 }">{{format(sum['充值']).toFixed(3)}}</vs-td>
              <vs-td :class="{ 'font-bold': format(sum['提现']) != 0 }">{{format(sum['提现']).toFixed(3)}}</vs-td>
              <vs-td :class="{ 'font-bold': format(sum['转账']) != 0 }">{{format(sum['转账']).toFixed(3)}}</vs-td>
              <vs-td v-if="showLottery && showGame" :class="{ 'font-bold': calBet(sum, ['彩票', '真人'], '投注') != 0 }">{{calBet(sum, ['彩票', '真人'], '投注').toFixed(3)}}</vs-td>
              <vs-td v-if="showLottery && showGame" :class="{ 'font-bold': calBet(sum, ['彩票', '真人'], '返奖') != 0 }">{{calBet(sum, ['彩票', '真人'], '返奖').toFixed(3)}}</vs-td>
              <vs-td v-if="showLottery && showGame" :class="{ 'font-bold': calBet(sum, ['彩票', '真人'], '提成') != 0 }">{{calBet(sum, ['彩票', '真人'], '提成').toFixed(3)}}</vs-td>
              <vs-td v-if="showLottery" :class="{ 'font-bold': calBet(sum, ['彩票'], '投注') != 0 }">{{calBet(sum, ['彩票'], '投注').toFixed(3)}}</vs-td>
			  <vs-td v-if="showLottery" :class="{ 'font-bold': calBet(sum, ['彩票'], '返奖') != 0 }">{{calBet(sum, ['彩票'], '返奖').toFixed(3)}}</vs-td>
              <vs-td v-if="showGame" :class="{ 'font-bold': calBet(sum, ['真人'], '投注') != 0 }">{{calBet(sum, ['真人'], '投注').toFixed(3)}}</vs-td>
              <vs-td v-if="showGame" :class="{ 'font-bold': calBet(sum, ['真人'], '返奖') != 0 }">{{calBet(sum, ['真人'], '返奖').toFixed(3)}}</vs-td>
              <!-- <vs-td v-if="showLottery" :class="{ 'font-bold': calBet(sum, ['彩票'], '提成') != 0 }">{{calBet(sum, ['彩票'], '提成').toFixed(3)}}</vs-td>
              <vs-td v-if="showGame" :class="{ 'font-bold': calBet(sum, ['真人'], '提成') != 0 }">{{calBet(sum, ['真人'], '提成').toFixed(3)}}</vs-td> -->
			  <vs-td v-if="showGame" :class="{ 'font-bold': calBet(sum, ['真人'], '转出') != 0 }">{{calBet(sum, ['真人'], '转出').toFixed(3)}}</vs-td>
			  <vs-td v-if="showGame" :class="{ 'font-bold': calBet(sum, ['真人'], '转入') != 0 }">{{calBet(sum, ['真人'], '转入').toFixed(3)}}</vs-td>
			  
              <vs-td :class="{ 'font-bold': calBet(sum, [showLottery ? '彩票' : null, showGame ? '真人' : null], '活动') != 0 }">{{calBet(sum, [showLottery ? '彩票' : null, showGame ? '真人' : null], '活动').toFixed(3)}}</vs-td>
              <vs-td :class="{ 'font-bold': calSumJing(sum) }">{{calSumJing(sum).toFixed(3)}}</vs-td>
							<vs-td :class="{ 'font-bold': calSum(sum) }">{{calSum(sum).toFixed(3)}}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>

    </vx-card>

  </div>
</template>

<script>

import { Mandarin as flatPickrZh } from 'flatpickr/dist/l10n/zh.js'

export default {
  data() {
    return {
      list: {},
      sum: {},
      startTime: '',
      endTime: '',
      rangeList: { '': '范围', self: '自身', direct: '直属', team: '团队' },
      range: '',
      typeList: ['按时间', '按会员'],
      typeIndex: 0,
      uid: '',
      showLottery: true,
      showGame: true,
      flatPickrConfig: {
        enableTime: false,
        dateFormat: 'Y-m-d',
        locale: flatPickrZh
      }
    }
  },
  methods: {
    load () {
      const postdata = {}
      postdata.authKey = localStorage.getItem('authKey')
      postdata.start = this.startTime
      postdata.end = this.endTime
      postdata.uid = this.uid
      postdata.range = this.range
      postdata.type = this.typeIndex
      this.$utils.post('report-team', postdata).then(data => {
        this.list = {}
        let d
        for (let i = 0; i < data.length; i++) {
          d = data[i]
          if (this.typeIndex === 0) {
            if (!this.list[d.date]) this.list[d.date] = {}
            if (!this.list[d.date][d.type]) this.list[d.date][d.type] = 0
            this.list[d.date][d.type] += parseFloat(d.total)
          } else if (this.typeIndex === 1) {
            if (!this.list[d.username]) this.list[d.username] = {}
            if (!this.list[d.username][d.type]) this.list[d.username][d.type] = 0
            this.list[d.username][d.type] += parseFloat(d.total)
          }
        }
        this.sum = {}
        for (const i in this.list) {
          for (const k in this.list[i]) {
            if (!this.sum[k]) this.sum[k] = 0
            this.sum[k] = (parseFloat(this.sum[k]) + this.list[i][k]).toFixed(4)
            this.list[i][k] = this.list[i][k].toFixed(4)
          }
        }
      })
    },
    search() {
      this.load()
    }
  },
  computed: {
    dateList () {
      if (this.typeIndex === 1) return Object.keys(this.list)
      const start = new Date(this.startTime.replace(/-/g, '/') + ' 00:00:00').getTime()
      const end = new Date(this.endTime.replace(/-/g, '/') + ' 00:00:01').getTime()
      const date = new Date()
      const list = []
      let dateFormat
      for (let i = end; i >= start; i -= 86400000) {
        date.setTime(i)
        dateFormat = this.$utils.addZero(date.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(date.getMonth()) + 1), 2) + '-' + this.$utils.addZero(date.getDate(), 2)
        if (list.indexOf(dateFormat) > -1) continue
        list.push(dateFormat)
      }
      return list
    },
    format () {
    	return function (data) {
    		data = parseFloat(data)
    		if (isNaN(data)) data = 0
    		return data
    	}
    },
    calBet () {
      return function (data, arr, type) {
        let sum = 0
        let count
        for (let i = 0; i < arr.length; i++) {
          count = this.format(data[arr[i] + type])
          if (arr[i] + type === '彩票投注') count -= this.format(data['彩票撤单'])
          sum += count
        }
        return this.format(sum)
      }
    },
    calActivity () {
      return function (data) {
        let sum
        if (this.showLottery && this.showGame) {
          sum = this.format(data['彩票活动']) + this.format(data['真人活动']) + this.format(data['其他活动'])
        } else if (this.showLottery) {
          sum = this.format(data['彩票活动'])
        } else if (this.showGame) {
          sum = this.format(data['真人活动'])
        }
        return this.format(sum)
      }
    },
    calSum () {
    	return function (data) {
        let sum = 0
        const arr = [this.showLottery ? '彩票' : null, this.showGame ? '真人' : null]
        sum += this.calBet(data, arr, '提成')
        sum += this.calBet(data, arr, '返奖')
        sum += this.calBet(data, arr, '活动')
        sum -= this.calBet(data, arr, '投注')
        sum += this.format(data['转账'])
		sum += this.format(data['真人转出'])
		sum += this.format(data['真人转入'])
    		return this.format(sum)
    	}
    },
    calSumJing () {
    	return function (data) {
        let sum = 0
        const arr = [this.showLottery ? '彩票' : null, this.showGame ? '真人' : null]
        sum += this.calBet(data, arr, '返奖')
        sum -= this.calBet(data, arr, '投注')
        return this.format(sum)
    	}
    }
  },
  mounted () {
    // 初始化时间
    const myDate = new Date()
    this.endTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)
    myDate.setTime(myDate.getTime() - 86400000 * 0)
    this.startTime = this.$utils.addZero(myDate.getFullYear(), 2) + '-' + this.$utils.addZero((parseInt(myDate.getMonth()) + 1), 2) + '-' + this.$utils.addZero(myDate.getDate(), 2)

    this.load()
  }
}
</script>
